export default __webpack_public_path__ + "static/media/measurement_example.a26445ae.webp";